module.exports = __webpack_public_path__ + "static/outsourcing-5fc1fb7d4a4f1fca0134d0171656212a.jpg";